import { get, writable } from 'svelte/store';
import { navigate } from '../../../app.logic';
import { QualityInternalMaintenanceService } from '../../../services/quality-internal-maintenance.service';
import { formatDateOnlyISO } from '../../../utils/date-utils';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    if (oid == 0) {
        record.set({ oid: 0, maintenanceDate: formatDateOnlyISO(new Date()), maintainer: "", description: "" });
    }
    else {
        let _resp = await QualityInternalMaintenanceService.fetchQualityInternalMaintenance(oid);
        record.set(_resp.payload);
    }
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await QualityInternalMaintenanceService.getQualityInternalMaintenances(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    navigate(`/quality-internal-maintenance/0`);
}
export function onEdit(item) {
    navigate(`/quality-internal-maintenance/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return await QualityInternalMaintenanceService.saveQualityInternalMaintenance(_record);
}
export async function onDelete(item) {
    await QualityInternalMaintenanceService.deleteQualityInternalMaintenance(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
